import type { ExperienceListDto, OrganizationDto } from "@intelligems/ig-types";

export const checkOfferLimit = (
  organization: OrganizationDto,
  personalizationsList?: ExperienceListDto[],
  experienceList?: ExperienceListDto[]
): boolean => {
  const orgLimit = organization.configurations.find(
    (config) => config.key === "max_enabled_offers"
  );

  const maxEnabledOffers: number = (orgLimit?.value ?? 15) as number;

  const combinedExperiences = [
    ...(personalizationsList || []),
    ...(experienceList || []),
  ];

  const enabledOfferExperiences = combinedExperiences.filter(
    (experience) =>
      (experience.status === "started" ||
        experience.status === "paused" ||
        experience.status === "pending") &&
      experience.archivedAtTs === null
  );

  let totalOffers = 0;
  enabledOfferExperiences.forEach((experience) => {
    if (experience.variations) {
      experience.variations.forEach((variation) => {
        if (variation.offerId) {
          totalOffers += 1;
        }
      });
    }
  });

  // Compare total offers with the organization limit
  return totalOffers < maxEnabledOffers;
};
